import { Link, useCanGoBack, useRouter } from '@tanstack/react-router'
import { Button } from '../ui/button'

export default function NotFound404() {
	const router = useRouter()
	const canGoBack = useCanGoBack()
	return (
		<div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 p-4 text-center">
			<h1 className="text-4xl font-bold">
				Not what you were looking for?
			</h1>
			<p className="text-lg">
				Sorry, we cannot find the page you are looking for, return{' '}
				{canGoBack && (
					<>
						<br />
						<span>
							to your
							<Button
								variant={'link'}
								className="px-2 text-base cursor-pointer"
								onClick={() => router.history.back()}
							>
								{' '}
								previous
							</Button>
							page or go
						</span>
					</>
				)}
				to the
				<Button className="pl-2 text-base" variant={'link'} asChild>
					<Link to="/">homepage.</Link>
				</Button>
			</p>
		</div>
	)
}
